module.exports = __webpack_public_path__ + "static/abdelghani-scrubs-a1f1523c1ed42b269ee02abc27c0cc0b.jpg";